import { makeActionCreator } from '../../../core/types/redux';
import {
  RequestRequestListArgs,
  ResultActionConstants as C,
  SetPaginationArgs,
  SetRequestListArgs,
  SetSearchFilterArgs,
} from './types';

const create = makeActionCreator<C>();

export const initialize = create(C.INITIALIZE);
export const setSearchFilter = create<SetSearchFilterArgs>(C.SEARCH_FILTER_SET);
export const setPagination = create<SetPaginationArgs>(C.PAGINATION_SET);
export const requestRequestList = create<RequestRequestListArgs>(C.REQUEST_LIST_REQUEST);
export const setRequestList = create<SetRequestListArgs>(C.REQUEST_LIST_SET);
